'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIBreakString;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UIBreakString(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hyphenate = _ref.hyphenate,
      rest = _objectWithoutProperties(_ref, ['children', 'className', 'hyphenate']);

  return _react2.default.createElement(
    'span',
    _extends({}, rest, {
      className: (0, _classNames2.default)('private-break-string', className, {
        'private-break-string--hyphenate': hyphenate,
        'private-break-string--no-hyphenate': !hyphenate
      })
    }),
    children
  );
}

UIBreakString.propTypes = {
  children: _react.PropTypes.node.isRequired,
  className: _react.PropTypes.string,
  hyphenate: _react.PropTypes.bool
};

UIBreakString.defaultProps = {
  hyphenate: true
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/text/UIBreakString.js
// module id = 537
// module chunks = 2 3